const UUID_DASH_POSITIONS: number[] = [8, 13, 18, 23];

function insertUuidDashes(value: string): string {
  let result: string = value;
  for (let i: number = 0; i < UUID_DASH_POSITIONS.length; i++) {
    const pos: number = UUID_DASH_POSITIONS[i];
    if (result.length > pos) {
      result = `${result.slice(0, pos)}-${result.slice(pos)}`;
    }
  }
  return result;
}

export function uuid(size: number = 32): string {
  let initialCode: string = '';
  for (let i: number = 0; i < size; i++) initialCode += '0';
  const raw: string = initialCode
    .replace(/[018]/g, (c) =>
      (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
    )
    .toUpperCase();

  return insertUuidDashes(raw);
}
